import React from 'react';
import { useHistory } from 'react-router-dom';
import { Title, Paragraph, List, ListItem } from './DeleteModal.styles';
import { Button } from '@material-ui/core';

import { exitReact } from 'utils';
import FixedLoader from '../FixedLoader';
import FixedError from '../FixedError';

import useActionApi from 'hooks/useActionApi';
import Api from 'api';

import { SimpleModal } from 'components/Modal';

interface DeletionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading: boolean;
}

const DeleteModal = ({ isOpen, onClose, onConfirm, loading }: DeletionModalProps) => {
    const goBack = () => {
        exitReact('home', {}, "bwd");
        onClose();
    };

    const handleConfirm = () => {
        onConfirm();
    }

    return (
        <SimpleModal isOpen={isOpen} onClose={onClose}>
            <Title>Are you sure?</Title>
            <Paragraph>By hitting "Yes", the following will happen:</Paragraph>
            <List>
                <ListItem>You will be immediately signed out of your TempStars account</ListItem>
                <ListItem>Will not be able to log into your TempStars account and will lose access to any records and/or invoices on your TempStars account</ListItem>
                <ListItem>You won't be able recreate an account using the same or similar credentials</ListItem>
                <ListItem>All booked shifts will be immediately cancelled and all active offers removed</ListItem>
            </List>
            <Paragraph>TempStars customer support team is always available to help or answer questions!</Paragraph>
            <Button  
                variant="contained"
                color="primary"
                size="medium"
                className="bigButtonInNewStyle"
                onClick={handleConfirm}
                disabled={loading}>
                YES - Delete My Account
            </Button>
            <Button  
                variant="outlined"
                color="primary"
                size="medium"
                className="bigButtonInNewStyle"
                onClick={goBack}
                disabled={loading}>
                Go back
            </Button>
        </SimpleModal>
    );
};

export default DeleteModal;
